import { useEffect, useRef } from "react";

export default function useActiveRef(value: any) {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
}
